import { render, staticRenderFns } from "./change-pass-card.vue?vue&type=template&id=11ee8cdc&scoped=true"
import script from "./change-pass-card.vue?vue&type=script&lang=ts"
export * from "./change-pass-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ee8cdc",
  null
  
)

export default component.exports